import "./Chooseus.css";

const Chooseus = () => {
  const cards = [
    {
      id: 1,
      img: "/assets/images/fast.png",
      alt: "Fast implementation",
      title: "Fast Implementation",
      desc: "VENSAP accelerates digital transformation with rapid deployment capabilities. A tailored POC is developed to meet business needs, followed by a streamlined implementation process that goes live in weeks.",
    },
    {
      id: 2,
      img: "/assets/images/fullconfigure.png",
      alt: "Fully configurable",
      title: "Fully Configurable",
      desc: "With powerful configuration flexibility, VENSAP empowers businesses to customize workflows, rules, and processes to align seamlessly with their unique operational needs.",
    },
    {
      id: 3,
      img: "/assets/images/highusability.png",
      alt: "High usability",
      title: "High Usability",
      desc: "With a modern and easy-to-navigate interface, users can seamlessly transition to the system, driving faster adoption and greater efficiency across the organization.",
    },
    {
      id: 4,
      img: "/assets/images/security.png",
      alt: "Data security",
      title: "Data Security",
      desc: "Built with enterprise-grade security frameworks, VENSAP safeguards sensitive business information, ensuring data confidentiality, integrity, and compliance at every level.",
    },
    {
      id: 5,
      img: "/assets/images/customerser.png",
      alt: "Customer support",
      title: "Customer Support & Maintenance",
      desc: "With proactive maintenance, timely patch updates, and continuous system optimization, VENSAP ensures seamless performance. A dedicated account manager and support team works closely with each client to drive adoption, resolve queries, and deliver measurable value.",
    },
    {
      id: 6,
      img: "/assets/images/bestvalue.png",
      alt: "Best value",
      title: "Best Value & Scalable Pricing",
      desc: "With a flexible pay-as-you-go pricing model, VENSAP allows organizations to optimize costs by subscribing only to the modules they use, ensuring maximum value and financial control.",
    },
  ];

  return (
    <section className="why-vensap">
      <div className="why-header">
        <h1>Why businesses choose VENSAP?</h1>
        <p>
          Organizations relying on manual tools such as email and Excel often
          face productivity losses, limited visibility, and compliance risks.
          VENSAP leverages advanced technology to deliver a streamlined and
          adaptable business solution that enhances efficiency, strengthens
          governance, and drives measurable business value.
        </p>
      </div>

      <div className="why-cards">
        {cards.map((card) => (
          <div key={card.id} className="why-card">
            <div className="image-box">
              <img src={card.img} alt={card.alt} loading="lazy" />
            </div>
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Chooseus;
